import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { PilotControlledLighting } from '../models/pilot-controlled-lighting.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PilotControlledLightingService } from '../service/pilot-controlled-lighting.service';
var EditPilotControlledLightingComponent = /** @class */ (function () {
    function EditPilotControlledLightingComponent(_matDialogRef, _pilotControlledLightingService, _snackBar, data) {
        this._matDialogRef = _matDialogRef;
        this._pilotControlledLightingService = _pilotControlledLightingService;
        this._snackBar = _snackBar;
        this.isNew = false;
        this.isLoading = false;
        this.pcl = data.pcl || new PilotControlledLighting();
        this.isNew = data.isNew || false;
        if (this.isNew) {
            this.pcl.clicks = 1;
            this.pcl.intensity = PilotControlledLighting.parseLightingIntensity('high');
            this.pcl.seconds = 1;
        }
        this.airportID = data.airID;
        this.origPcl = Object.assign(new PilotControlledLighting(), data.pcl);
        this.itemsToChange = new Set();
        this.selectedIntensity = PilotControlledLighting.formatLightingIntensity(this.pcl.intensity).toLowerCase();
        this.selectedClicks = this.pcl.clicks;
        this.selectedSeconds = this.pcl.seconds;
        this.PCL = data.PCL || [];
    }
    EditPilotControlledLightingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            intensity: new FormControl(this.selectedIntensity, [Validators.required]),
            clicks: new FormControl(this.selectedClicks, [Validators.required]),
            seconds: new FormControl(this.selectedSeconds, [Validators.required])
        });
    };
    EditPilotControlledLightingComponent.prototype.numOfClicksUnfocus = function () {
        var CLICKS = this.selectedClicks;
        this.selectedClicks = (!CLICKS || CLICKS < 1) ? 1 : Math.floor(CLICKS);
    };
    EditPilotControlledLightingComponent.prototype.numOfSecondsUnfocus = function () {
        var SECONDS = this.selectedSeconds;
        this.selectedSeconds = (!SECONDS || SECONDS < 1) ? 1 : Math.floor(SECONDS);
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditPilotControlledLightingComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.pcl.intensity = PilotControlledLighting.parseLightingIntensity(this.formGroup.get('intensity').value.toLowerCase());
                        this.pcl.clicks = this.formGroup.get('clicks').value;
                        this.pcl.seconds = this.formGroup.get('seconds').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        if (this.PCL.filter(function (element) { return element.intensity === _this.pcl.intensity; }).length > 0) {
                            this._snackBar.open('There is already a lighting entry for this lighting intensity.  ' +
                                'If it is incorrect, please go back end edit it.', 'Pilot Activated Lighting', {
                                duration: 8000
                            });
                            return [2 /*return*/];
                        }
                        if (this.PCL.filter(function (element) { return element.clicks === _this.pcl.clicks; }).length > 0) {
                            this._snackBar.open('There is already a lighting entry for this number of clicks.  ' +
                                'If it is incorrect, please go back end edit it.', 'Pilot Activated Lighting', {
                                duration: 8000
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._pilotControlledLightingService.postPCL(this.airportID, this.pcl)];
                    case 1:
                        res = _a.sent();
                        this.pcl = PilotControlledLighting.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._pilotControlledLightingService.putPCL(this.airportID, this.pcl)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.pcl, PilotControlledLighting.parse(res));
                        this.pcl = PilotControlledLighting.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, alert: this.pcl });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditPilotControlledLightingComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditPilotControlledLightingComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.pcl, this.origPcl);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditPilotControlledLightingComponent;
}());
export { EditPilotControlledLightingComponent };
